export interface JiraIssue {
    issueSummary: string;
    issueType: string;
    issueUrl: string;
}

export enum IssueType {
    Caption = 'Caption',
    Metadata = 'Metadata',
    Art = 'Art',
    VideoAudio = 'Video/Audio',
    AdBreak = 'Ad-break',
    ApiJson = 'API/JSON',
    Misdelivery = 'Misdelivery',
    Other = 'Other'
}

export enum MisdeliveryDetails {
    Missing = 'Missing',
    Incorrect = 'Incorrect',
    Transposed = 'Transposed',
}

export enum MisdeliveryTypesAffected {
    Artwork = 'Artwork',
    Audio = 'Audio',
    Captions = 'Captions',
    Video = 'Video',
}

export enum CaptionTypeDetails {
    Sync = 'Sync',
    Positioning = 'Position',
    Overlap = 'Overlap',
    Missing = 'Missing',
    Other = 'Other',
}

export enum ArtTypeDetails {
    Poster = 'Poster',
    Featured = 'Featured',
    ScreenshotBig = 'Screenshot 1920 x 1080',
    ScreenshotSmall = 'Screenshot 1440 x 1080',
    Square = 'Square 1080 x 1080',
}

export enum AdBreakTypeDetails {
    MissingBreakpoints = 'Missing breakpoints',
    IncorrectBreakpoints = 'Incorrect breakpoints',
    ExtendedAdBlackTime = 'Extended ad-black time',
}

export enum DropFrameValues {
    NDF = 'NDF',
    DF = 'DF',
}

export enum FrameRateValues {
    FirstRate = '23.98',
    SecondRate = '24',
    ThirdRate = '25',
    FourthRate = '29.97',
    FifthRate = '30',
    SixthRate = '50',
    SeventhRate = '59.94',
}

export enum IngestionBlockValues {
    Blocked = 'Blocked',
    NotBlocked = 'Not blocked',
}

export enum AspectRatioValues {
    FirstValue = '4:3',
    SecondValue = '16:9',
}

export interface CreateIssueBody {
    summary: string;
    description: string;
    issuetype: string;
    dropFrame: string;
    frameRate: string;
    aspectRatio: string;
    issueDetails: string[];
    typesAffected: string[];
    abIssueDetail: string[];
    ingestionBlock: string;
}

export interface CreatMultipleIssueBody extends CreateIssueBody {
    qcJobIds: number[];
}

export interface CreateIssueParams {
    id: number;
    body: CreateIssueBody;
    offset?: string;
    limit?: string;
}

export interface CreateMultipleIssueParams {
    body: CreatMultipleIssueBody;
    offset?: string;
    limit?: string;
}
